{
  "commonHeader": {
    "toggleSidebar": "Przełącz panel boczny",
    "cartLoading": "Ładowanie koszyka",
    "cart": "Koszyk",
    "aicForAdmin": {
      "ariaLabel": "AI dla administratorów"
    },
    "usersResults": "Użytkownicy, liczba wyników: {0}",
    "settingsResults": "Ustawienia, liczba wyników: {0}",
    "navigationResults": "Nawigacja, liczba wyników: {0}",
    "learnMoreAbout": "Dowiedz się więcej o {0}",
    "close": "Zamknij",
    "products": "Produkty",
    "moreActions": "Więcej działań",
    "search": "Szukaj",
    "searchPlaceholderAll": "Szukaj użytkowników, ustawień konta lub nawigacji",
    "searchPlaceholderUsers": "Szukaj użytkowników lub nawigacji",
    "searchPlaceholderSettings": "Szukaj ustawień konta lub nawigacji",
    "searchPlaceholderNav": "Szukaj w nawigacji"
  },
  "footerCopyright": {
    "language": "Język {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu administratora"
    }
  },
  "shared": {
    "close": "Zamknij",
    "sideMenu": {
      "personalAria": "Menu osobiste",
      "adminAria": "Menu administratora",
      "mainNav": "Nawigacja główna",
      "submenu": "Podmenu",
      "pinnedSection": "{0} przypięte",
      "sideMenuAria": "Menu boczne",
      "pinItem": "Przypnij {0}",
      "unpinItem": "Odepnij {0}",
      "reorderGrabbed": "Zmiana kolejności {0}, chwyt aktywny. Użyj strzałek w górę i w dół, aby przenieść, spacji lub Enter, aby upuścić, Escape, aby anulować.",
      "reorderIdle": "Zmień kolejność {0}. Naciśnij spację lub Enter, aby chwycić.",
      "hintHandlePin": "Naciśnij Tab, aby uzyskać dostęp do uchwytu przeciągania i przycisku przypinania",
      "hintHandle": "Naciśnij Tab, aby uzyskać dostęp do uchwytu przeciągania",
      "hintPin": "Naciśnij Tab, aby uzyskać dostęp do przycisku przypinania",
      "upgradeToPro": "Przejdź na Pro"
    },
    "item": "Element"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Wypróbuj nowe środowisko"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Zamknij"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Dywizje są już dostępne"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Zarządzaj kontami zewnętrznymi"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Książka adresowa stanie się Katalogiem klientów"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Obszar produktu",
    "itemLableForFeedback": "Informacje zwrotne"
  }
}
